import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "21",
  height: "13",
  viewBox: "0 0 21 13"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M14.553.256a1 1 0 0 0-1.42 1.402L16.054 5H2a1.25 1.25 0 1 0 0 2.5h14.373l-3.253 3.855a1 1 0 0 0 1.446 1.377l6.013-5.6a1 1 0 0 0-.014-1.476l-6.012-5.4z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }